<div class="url-shortener-modern">
  <!-- Unified Tool Header -->
  <div class="unified-tool-header">
    <div class="header-content">
      <div class="header-icon">
        <svg viewBox="0 0 24 24" class="tool-icon">
          <path
            d="M3.9,12C3.9,10.29 5.29,8.9 7,8.9H11V7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12M8,13H16V11H8V13M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.71 18.71,15.1 17,15.1H13V17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7Z"
          />
        </svg>
      </div>
      <div class="header-text">
        <h1>URL Shortener</h1>
        <p>Transform long URLs into short, shareable links instantly</p>
      </div>
    </div>
  </div>

  <!-- Tool Content -->
  <div class="tool-content">
    <!-- Input Section -->
    <div class="input-section">
      <div class="input-container">
        <div class="input-wrapper">
          <div class="input-icon">
            <svg viewBox="0 0 24 24">
              <path
                d="M16.36,14C16.44,13.34 16.5,12.68 16.5,12C16.5,11.32 16.44,10.66 16.36,10H19.74C19.9,10.64 20,11.31 20,12C20,12.69 19.9,13.36 19.74,14M14.59,19.56C15.19,18.45 15.65,17.25 15.97,16H18.92C17.96,17.65 16.43,18.93 14.59,19.56M14.34,14H9.66C9.56,13.34 9.5,12.68 9.5,12C9.5,11.32 9.56,10.65 9.66,10H14.34C14.43,10.65 14.5,11.32 14.5,12C14.5,12.68 14.43,13.34 14.34,14M12,19.96C11.17,18.76 10.5,17.43 10.09,16H13.91C13.5,17.43 12.83,18.76 12,19.96M8,8H5.08C6.03,6.34 7.57,5.06 9.4,4.44C8.8,5.55 8.35,6.75 8,8M5.08,16H8C8.35,17.25 8.8,18.45 9.4,19.56C7.57,18.93 6.03,17.65 5.08,16M4.26,14C4.1,13.36 4,12.69 4,12C4,11.31 4.1,10.64 4.26,10H7.64C7.56,10.66 7.5,11.32 7.5,12C7.5,12.68 7.56,13.34 7.64,14M12,4.03C12.83,5.23 13.5,6.57 13.91,8H10.09C10.5,6.57 11.17,5.23 12,4.03M18.92,8H15.97C15.65,6.75 15.19,5.55 14.59,4.44C16.43,5.07 17.96,6.34 18.92,8M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
              />
            </svg>
          </div>
          <textarea
            [(ngModel)]="urlInput"
            [value]="urlInput"
            (input)="urlInput = $any($event.target).value; onInputChange($event)"
            placeholder="Paste your URLs here... (separate multiple URLs with commas or new lines)"
            class="url-textarea"
            name="urlInput"
            (keydown)="onUrlInputKeydown($event)"
            rows="3"
          ></textarea>
          <div class="input-actions" *ngIf="urlInput.trim().length > 0">
            <button class="clear-input-btn" (click)="clearInput()" title="Clear input">
              <svg viewBox="0 0 24 24">
                <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
              </svg>
            </button>
          </div>
        </div>

        <div class="input-footer">
          <div class="input-info">
            <svg viewBox="0 0 24 24" class="info-icon">
              <path d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
            </svg>
            Supports multiple URLs separated by commas or new lines
          </div>
          <div class="keyboard-shortcut">
            <kbd>{{ keyboardModifier }}</kbd> + <kbd>Enter</kbd> to shorten
          </div>
        </div>
      </div>

      <button class="shorten-button" [disabled]="isButtonDisabled" [class.loading]="isLoading" (click)="handleShorten()">
        <div class="button-content">
          <div *ngIf="!isLoading" class="button-icon">
            <svg viewBox="0 0 24 24">
              <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
            </svg>
          </div>
          <div *ngIf="isLoading" class="loading-spinner"></div>
          {{ isLoading ? 'Shortening...' : 'Shorten URLs' }}
        </div>
      </button>
    </div>

    <!-- Results Section -->
    <div *ngIf="results.length > 0" class="results-section">
      <div class="results-header">
        <div class="results-title">
          <svg viewBox="0 0 24 24" class="results-icon">
            <path
              d="M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M7,6H17V8H7V6M7,9H17V11H7V9M7,12H14V14H7V12Z"
            />
          </svg>
          <div>
            <h2>Shortened URLs</h2>
            <span class="results-count">{{ results.length }} URL{{ results.length === 1 ? '' : 's' }} processed</span>
          </div>
        </div>
        <div class="results-actions">
          <button *ngIf="results.length > 1" class="action-btn copy-all-btn" [class.copied]="allCopied" (click)="copyAllToClipboard()" title="Copy all shortened URLs">
            <svg viewBox="0 0 24 24">
              <path d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z" />
            </svg>
            <span>{{ allCopied ? 'Copied!' : 'Copy All' }}</span>
          </button>
          <button class="action-btn clear-btn" (click)="clearResults()" title="Clear all results">
            <svg viewBox="0 0 24 24">
              <path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
            </svg>
            <span>Clear All</span>
          </button>
        </div>
      </div>

      <div class="results-grid">
        <div *ngFor="let result of results; let i = index" class="result-card" [class.copied]="result.isCopied">
          <div class="result-content">
            <div class="url-section">
              <div class="url-label">Original URL</div>
              <div class="url-value original-url" [title]="result.original">
                <svg viewBox="0 0 24 24" class="url-icon">
                  <path
                    d="M16.36,14C16.44,13.34 16.5,12.68 16.5,12C16.5,11.32 16.44,10.66 16.36,10H19.74C19.9,10.64 20,11.31 20,12C20,12.69 19.9,13.36 19.74,14M14.59,19.56C15.19,18.45 15.65,17.25 15.97,16H18.92C17.96,17.65 16.43,18.93 14.59,19.56M14.34,14H9.66C9.56,13.34 9.5,12.68 9.5,12C9.5,11.32 9.56,10.65 9.66,10H14.34C14.43,10.65 14.5,11.32 14.5,12C14.5,12.68 14.43,13.34 14.34,14M12,19.96C11.17,18.76 10.5,17.43 10.09,16H13.91C13.5,17.43 12.83,18.76 12,19.96M8,8H5.08C6.03,6.34 7.57,5.06 9.4,4.44C8.8,5.55 8.35,6.75 8,8M5.08,16H8C8.35,17.25 8.8,18.45 9.4,19.56C7.57,18.93 6.03,17.65 5.08,16M4.26,14C4.1,13.36 4,12.69 4,12C4,11.31 4.1,10.64 4.26,10H7.64C7.56,10.66 7.5,11.32 7.5,12C7.5,12.68 7.56,13.34 7.64,14M12,4.03C12.83,5.23 13.5,6.57 13.91,8H10.09C10.5,6.57 11.17,5.23 12,4.03M18.92,8H15.97C15.65,6.75 15.19,5.55 14.59,4.44C16.43,5.07 17.96,6.34 18.92,8M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                  />
                </svg>
                <span class="url-text">{{ result.original }}</span>
              </div>
            </div>

            <div class="arrow-section">
              <svg viewBox="0 0 24 24" class="arrow-icon">
                <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
              </svg>
            </div>

            <div class="url-section">
              <div class="url-label">Shortened URL</div>
              <div class="url-value shortened-url" [title]="result.shortened">
                <svg viewBox="0 0 24 24" class="url-icon shortened">
                  <path
                    d="M3.9,12C3.9,10.29 5.29,8.9 7,8.9H11V7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12M8,13H16V11H8V13M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.71 18.71,15.1 17,15.1H13V17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7Z"
                  />
                </svg>
                <span class="url-text">{{ result.shortened }}</span>
              </div>
            </div>
          </div>

          <div class="result-actions">
            <button
              class="copy-btn"
              (click)="copyToClipboard(result.shortened, i)"
              [disabled]="result.isCopied"
              [title]="result.isCopied ? 'Copied to clipboard!' : 'Copy to clipboard'"
            >
              <svg *ngIf="!result.isCopied" viewBox="0 0 24 24">
                <path d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z" />
              </svg>
              <svg *ngIf="result.isCopied" viewBox="0 0 24 24">
                <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
              </svg>
              <span>{{ result.isCopied ? 'Copied!' : 'Copy' }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Error State -->
    <div *ngIf="error" class="error-section">
      <div class="error-card">
        <svg viewBox="0 0 24 24" class="error-icon">
          <path d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
        </svg>
        <div class="error-content">
          <h3>Something went wrong</h3>
          <p>{{ error }}</p>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="results.length === 0 && !error && urlInput.trim() === ''" class="empty-state">
      <h3>Ready to shorten URLs</h3>
      <p>Paste your long URLs above and click "Shorten URLs" to get started</p>
      <div class="features-list">
        <div class="feature-item">
          <svg viewBox="0 0 24 24">
            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
          </svg>
          <span>Multiple URLs at once</span>
        </div>
        <div class="feature-item">
          <svg viewBox="0 0 24 24">
            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
          </svg>
          <span>Instant copy to clipboard</span>
        </div>
        <div class="feature-item">
          <svg viewBox="0 0 24 24">
            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
          </svg>
          <span>Fast and reliable</span>
        </div>
      </div>
    </div>
  </div>
  <!-- Close tool-content -->
</div>
